import { ConsentRequest } from '@monthio/react-components'
import { budgetApiClient } from './apis'

export async function giveConsent(consents: ConsentRequest[]) {
	try {
		await budgetApiClient.put('consent', consents)
	} catch (error: any) {
		return Promise.reject({
			name: error.response?.status + ':' + error.name,
			message: error.message,
			errorCode: error.response?.data?.errorCode ?? '',
			errorObject: error,
		})
	}
}
